// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"74d1cb6f","186":"728bf424","272":"c3025c79","372":"3c580d7d","738":"f8fdf521","841":"5854da8a","851":"b0af5f38","856":"ec396404"}[chunkId] + ".chunk.js";
};